<template>
  <div v-loading="loading">
    <el-form
      ref="form"
      :model="form"
      label-width="110px"
      id="feedback-form"
      :rules="rules"
    >
      <el-form-item label="选择车型:" prop="inputList">
        <carSearch
          @increment="appAddCounter"
          v-bind:inputList.sync="row"
          v-bind:searchType="3"
        ></carSearch>
      </el-form-item>
      <el-form-item label="购车裸车价:" prop="price_true">
        <el-input v-model="form.price_true"></el-input>
      </el-form-item>
      <el-form-item label="购车全款价:" prop="price_all">
        <el-input v-model="form.price_all"></el-input>
      </el-form-item>
      <el-form-item label="购车城市:" prop="purchase_city_name">
        <el-input v-model="form.purchase_city_name"></el-input>
      </el-form-item>
      <el-form-item label="备注:" prop="price_remark">
        <el-input v-model="form.price_remark"></el-input>
      </el-form-item>
      <el-form-item label="上传购车发票:" prop="price_invoice">
        <uploadImage
          @setImgFun="getImgUrl"
          :fileListArr.sync="row.price_invoice"
        ></uploadImage>
      </el-form-item>
      <el-form-item label="审核状态:" prop="review_type">
        <el-radio-group v-model="form.review_type">
          <el-radio :label="0">未审核</el-radio>
          <el-radio :label="1">已审核</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit('form')">提交</el-button>
        <el-button @click="close(2)">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import uploadImage from "../../components/upload-image/upload-image";
import carSearch from "../../components/car-search/car-search";
import {AllEdit} from "../../api/api"
export default {
  name: "car-user-price-form",
  components: {
    carSearch,
    uploadImage,
  },
  props: {
    layerid: String,
    edit: Boolean,
    keyword: Array,
    row: {
      default: function () {
        return [];
      },
    },
    seriesid: Number,
  },
  data() {
    let data = {
      bt: "创建",
      form: {
        brandid: "",
        seriesid: "",
        modelid: "",
      },
      loading: true,
      rules: {
        modelid: [{ required: true, message: "请选择车系", trigger: "change" }],
        price_true: [
          { required: true, message: "请输入裸车价", trigger: "blur" },
        ],
        price_all: [
          { required: true, message: "请输入全款价", trigger: "blur" },
        ],
      },
      logName: "",
      options: [],
      where: {
        series_name: "",
      },
      inputList: [],
      isShow:false
    };
    return data;
  },
  async mounted() {
    if (this.seriesid) this.form.seriesid = this.seriesid;
    if (this.edit) {
      let msg = await AllEdit("api/car-user-price/"+this.row.id);
      let {data} = msg;
      data = JSON.parse(data).data
      this.form = data;
      this.isShow = true;
      this.loading = false;
    }else{
      this.isShow = true;
      this.loading = false;
    }
  },
  methods: {
    onSubmit(e) {
      if (this.logName == "admin") this.form.userid = 1;
      if(this.form.price_invoice == "" || this.form.price_invoice == null){
        return this.$message.error("请您上传购车发票")
      }
      this.$refs[e].validate((valid) => {
        if (valid) {
          this.$emit("emitcaruser",{form:this.form})
        } else {
          this.$message.error("请检查表单完整性");
          return false;
        }
      });
    },
    close(e) {
      this.$emit("emitcaruser",{})
    },
    appAddCounter: function (e) {
      console.log("子组件传的值：", e);
      this.form.brandid = e["brandid"];
      if (e["seriesid"])
        this.form.seriesid = e["seriesid"] ? e["seriesid"] : "";
      if (e["modelid"]) this.form.modelid = e["modelid"] ? e["modelid"] : "";
    },
    getImgUrl(e) {
      console.log("子组件传的值：", e);
      this.form.price_invoice = JSON.stringify(e); //上传文件列表
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
.el-select {
  width: 100%;
}
</style>
<style>
.el-cascader--small {
  width: 100% !important;
}
</style>
